module.exports = __webpack_public_path__ + "static/media/web-ekyc-qr-code.c98b5f33.png";